var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCompute = function SvgCompute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.064 17.714a.643.643 0 0 1 0 1.286h-8.13a.644.644 0 0 1 0-1.286h8.13ZM16.348 1a2.79 2.79 0 0 1 2.787 2.786v9.285a2.79 2.79 0 0 1-2.787 2.786H3.652a2.79 2.79 0 0 1-2.787-2.786V3.786A2.79 2.79 0 0 1 3.652 1h12.696ZM3.652 2.286c-.827 0-1.5.673-1.5 1.5v9.285c0 .828.673 1.501 1.5 1.501h12.696c.827 0 1.5-.673 1.5-1.5V3.785c0-.827-.673-1.5-1.5-1.5H3.652Zm2.293 5.65c.355 0 .643.288.644.642v1.91a.644.644 0 0 1-1.287 0v-1.91c0-.354.289-.642.643-.642Zm3.972-2.617c.354 0 .642.29.642.644v4.524a.644.644 0 0 1-1.285 0V5.963c0-.355.288-.644.643-.644Zm4.011 1.448c.355 0 .643.288.643.642v3.078a.643.643 0 1 1-1.285 0V7.41c0-.354.288-.642.642-.642Z",
    fill: "#018DD7"
  })));
};

export default SvgCompute;